import { action } from 'typesafe-actions';
import { AUDIT } from '../constants/actions';

export const getAuditLogList = (filter: any) => action(AUDIT.AUDIT_LOG_LIST_REQUEST, filter);
export const setAuditLogList = (data: any) => action(AUDIT.AUDIT_LOG_LIST_RESPONSE, data);
export const getAuditLogDetails = (filter: any) => action(AUDIT.AUDIT_LOG_DETAILS_REQUEST, filter);
export const setAuditLogDetails = (data: any) => action(AUDIT.AUDIT_LOG_DETAILS_RESPONSE, data);
export const setEventTypes = (data: any) => action(AUDIT.SET_EVENT_TYPES, data);
